import { TBoxStructure } from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { ETableStructureType } from 'ui/EasTable/types';

export const invoiceManagementBoxStructure: TBoxStructure<{
	id: number;
	invoices_count: number;
	total_amount_in_eur_invoices: number;
	total_invoiced_amount_in_eur_invoices: number;
	total_paid_amount_in_eur: number;
	balance_in_eur: string;
}> = {
	body: [
		{
			name: 'Count',
			selector: 'invoices_count',
			type: ETableStructureType.NUMBER,
			editable: false,
		},
		{
			name: 'Amount',
			selector: 'total_amount_in_eur_invoices',
			type: ETableStructureType.AMOUNT,
			editable: false,
			show: false,
		},
		{
			name: 'Invoiced',
			selector: 'total_invoiced_amount_in_eur_invoices',
			type: ETableStructureType.AMOUNT,
			editable: false,
		},
		{
			name: 'Paid',
			selector: 'total_paid_amount_in_eur',
			type: ETableStructureType.AMOUNT,
			editable: false,
		},
		{
			name: 'Balance',
			selector: 'balance_in_eur',
			type: ETableStructureType.AMOUNT,
			editable: false,
		},
	],
	header: [],
	title: 'Invoice Summary',
};
